var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f4cb590d7c1f2e003b5580133428e98e48bf0b9b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["anima-web-app@anima"]={id:"f4cb590d7c1f2e003b5580133428e98e48bf0b9b"};
      